import { combineReducers } from 'redux';

import user from './userReducer';
import users from './usersDataReducer';
import product from './productReducer';
import order from './orderReducer';

export default combineReducers({
  user,
  users,
  product,
  order
});



// WEBPACK FOOTER //
// ./src/reducers/index.js